let TopNavMenu = [
  {
    name: 'Trang Chủ',
    link: '/',
    // isActive: '',
    hasSubmenu: false,
    subAuthen: [],
    subUnAuthen: []
  },
  {
    name: 'Cho doanh nghiệp',
    link: null,
    isActive: 'business',
    hasSubmenu: true,
    subAuthen: [
      {name: 'Doanh nghiệp Phuyen', link: '/phuyen-businesses', isActive: 'phuyen-businesses'},
      {name: 'Doanh ngiệp của tôi', link: '/my-business/edit', isActive: 'my-business'},
      {name: 'Bảng tin', link: '/my-business/dashboard', isActive: 'my-business-news'},
      {name: 'Đăng sản phẩm', link: '/my-business/post-product', isActive: 'my-business-post-product'},
      {name: 'Gửi nhu cầu', link: '/user/post-demand', isActive: 'post-demand'}
    ],
    subUnAuthen: [
      {name: 'Doanh nghiệp Phuyen', link: '/phuyen-businesses', isActive: 'phuyen-businesses', isDontNeedLogin: true},
      {name: 'Đăng ký doanh nghiệp', link: '/register-business', isActive: 'register-business'},
      {name: 'Đăng sản phẩm', link: '/my-business/post-product', isActive: 'my-business-post-product'},
      {name: 'Gửi nhu cầu', link: '/user/post-demand', isActive: 'post-demand'}
    ]
  },{
    name: 'Cho cá nhân',
    link: null,
    isActive: 'user',
    hasSubmenu: true,
    subAuthen: [
      {name: 'Bảng tin', link: '/dashboard', isActive: 'dashboard'},
      {name: 'Hồ sơ cá nhân', link: '/profile', isActive: 'profile'},
      {name: 'Gửi nhu cầu', link: '/user/post-demand', isActive: 'post-demand'}
    ],
    subUnAuthen: [
      {name: 'Đăng ký', link: '/signup', isActive: 'signup', isDontNeedLogin: true},
      {name: 'Đăng nhập', link: '/signin', isActive: 'signin'},
      {name: 'Gửi nhu cầu', link: '/user/post-demand', isActive: 'post-demand'}
    ]
  },{
    name: 'Hướng dẫn',
    link: '/faq',
    hasSubmenu: false,
    subAuthen: [],
    subUnAuthen: []
  }
];

export {
  TopNavMenu
};



// WEBPACK FOOTER //
// ./components/layouts/master/sub-header/TopNavConfig.jsx